<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 mb-base">
        <general-information></general-information>
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 mb-base">
        <prosecution-transaction></prosecution-transaction>
      </div>
    </div>
  </div>
</template>

<script>
import GeneralInformation from "./components/GeneralInformation.vue";
import ProsecutionTransaction from "./components/ProsecutionTransaction.vue";
import {createNamespacedHelpers} from "vuex";

const {mapActions: mapProsecutionActions, mapState: mapProsecutionState} = createNamespacedHelpers('Prosecution')

export default {
  components: {
    GeneralInformation,
    ProsecutionTransaction
  },
  async created () {
    const vm = this;
    const { getProsecution } = vm;
    await getProsecution({form: {id: vm.$route.params.prosecutionId}})
  },
  computed:{
    ...mapProsecutionState(['prosecution']),
  },
  methods:{
    ...mapProsecutionActions(['getProsecution']),
    reloadComponent(params) {
      this.$vs.loading(); // Show loading state
      this.getProsecution({ form: { id: params.prosecutionId } })
        .then(() => this.$vs.loading.close()) // Close loading when done
        .catch(() => this.$vs.loading.close()); // Close on error
    }
  },
  watch: {
    status: {
      handler(res){
        if(res.processing !== null){
          if(res.processing){
            this.$vs.loading();
          }else{
            this.$vs.loading.close();
          }
        }
        if(res.success !== null){
          this.$vs.notify({...res.success})
        }else if(res.error !== null){
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    },
    '$route.params': {
      handler(newParams, oldParams) {
        if (newParams.contractId !== oldParams.contractId || newParams.prosecutionId !== oldParams.prosecutionId) {
          this.reloadComponent(newParams);
        }
      },
      deep: true,
      immediate: true
    }
  },
}
</script>
